import {createSinglePathSVG, createStrokeSVG} from './TEMPLATE'

// phosphor: user-circle (fill)
export const UserCircle_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M172,120a44,44,0,1,1-44-44A44.05,44.05,0,0,1,172,120Zm60,8A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88.09,88.09,0,0,0-91.47-87.93C77.43,41.89,39.87,81.12,40,128.25a87.65,87.65,0,0,0,22.24,58.16A79.71,79.71,0,0,1,84,165.1a4,4,0,0,1,4.83.32,59.83,59.83,0,0,0,78.28,0,4,4,0,0,1,4.83-.32,79.71,79.71,0,0,1,21.79,21.31A87.62,87.62,0,0,0,216,128Z',
  viewBox: '0 0 256 256',
})

// tabler: user-circle
export const UserCircle_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
    'M9 10a3 3 0 1 0 6 0a3 3 0 1 0 -6 0',
    'M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
